/**
 * Public Cloudflare Turnstile site key for the public forms.
 *
 *   REACT_APP_TURNSTILE_SITE_KEY=<site key from the Cloudflare dashboard>
 *
 * Optional. Empty means no widget is rendered and no token is sent; the backend
 * then skips verification unless its own TURNSTILE_SECRET_KEY is set (in which
 * case it refuses forms without a token, so set both together). The site key is
 * public by design; the secret key never belongs in this repository.
 *
 * Create React App inlines REACT_APP_* values at build time.
 */
export const TURNSTILE_SITE_KEY_ENV = "REACT_APP_TURNSTILE_SITE_KEY";

export function getTurnstileSiteKey() {
  // CRA only inlines the variable when it is referenced by its full name.
  return (process.env.REACT_APP_TURNSTILE_SITE_KEY || "").trim();
}
